import { render, staticRenderFns } from "./AddNewPatientCard.vue?vue&type=template&id=b6a5a640&scoped=true"
import script from "./AddNewPatientCard.vue?vue&type=script&lang=js"
export * from "./AddNewPatientCard.vue?vue&type=script&lang=js"
import style0 from "./AddNewPatientCard.vue?vue&type=style&index=0&id=b6a5a640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a5a640",
  null
  
)

export default component.exports